<template lang="html">
    <div class="col-cart-data loggedin-cart">
  
        <div class="col-12 pt-3 product-list-table">
            <div class="row row-products align-items-center row-history" v-if="!certificates.length">
                No tienes certificados guardados
            </div>
  
            <div class="row"   style="display: flex;max-width: 100%;padding: 14px 2px 8px;">
                <div class="col-3 col-menu">
                    <div class="white-box">
                        <button @click="addFolder" class="btn btn-sm btn-s1 bg-blue" style="font-size: 11px;"> <i class="fas fa-plus"></i> Nueva carpeta</button>
                        <div class="box-menu">
                            <p class="item">
                                <a class="btn-menu btn-menu router-link-exact-active router-link-active" v-if="activeFold == 99999999" > Todos</a>
                                <a class="btn-menu" v-else  @click="activeFold = 99999999"> ...</a>
                            </p>
                            <p class="item"  v-for="(fold, cInx) in folders" :key="'fold-'+cInx">
                                <a class="btn-menu btn-menu router-link-exact-active router-link-active" v-if="activeFold == fold.id" @click="activeFold = fold.id"> {{ fold.name }}</a>
                                <a class="btn-menu" v-else @click="activeFold = fold.id"> {{ fold.name }}</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-8">
                    <button @click="moveFolder" class="btn btn-success" style="font-size: 12px;width: 100%;"> <i class="fas fa-exchange-alt"></i> Mover a carpeta</button>
                    <button v-if="activeFold != 99999999" @click="deleteFolder" class="btn btn-danger" style="font-size: 12px;width: 100%;"> <i class="fas fa-trash"></i> Eliminar</button>
                    
                    <div class="box-contract" v-for="(c, cInx) in rows" :key="'cInx-'+cInx">
                      

                        <div class="row" style="padding-top: 20px;">
                          <div class="col-1">
                            <input type="checkbox" style="text-align: left;transform: scale(1.5);margin-left: 16px;" v-model="form_change.check_signatured" :value="c.id" :id="'check-'+c.id">
                     
                            </div>
                          

                            <div class="col-9">
                                <h6 class="mb-0"><router-link style="color: #57b68c;" :to="'/coa/'+c.id">
                                <b>{{ c.ide }}</b></router-link></h6>
                                <br>
                                <label class="label">Carpeta: <b>{{ c.folder_name }}</b></label>
                            </div>
                            <div class="col-2">
                               <div> <b>{{ c.brand }}</b> </div>
                                <div><img :src="c.imageUrl" width="100px"></div>
                            </div>
                        </div>
                       
             
                        
                    </div>
                </div>
            
            <!-- <div class="col">
                <div class="card card-2">
                    <div class="card-body">
                        <div class="media">
                            <div class="media-body my-auto text-right">
                                <div class="row my-auto flex-column flex-md-row">
                                    <div class="col-auto my-auto ">
                                        <h6 class="mb-0"><router-link style="color: #57b68c;" :to="'/coa/'+cer.id">
                                        <b>{{ cer.ide }}</b></router-link>
                                        </h6>
                                    </div>
                                    <div class="col my-auto "> <b>{{ cer.brand }}</b> </div>
                                    <div class="col my-auto "><img :src="cer.imageUrl" width="100px"></div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
  
      </div>
        
        <sweet-modal ref="foldermodal">
            <b-form class="c-f-g-2-wrp sm" @submit="onSubmit">
                <b-form-group class="cus-f-group-2" label="Nombre de la carpeta">
                    <b-form-input type="text" v-model="formfolder.name"  size="sm" placeholder="" />
                </b-form-group>

                <b-button type="submit" class="btn-s1 bg-blue">Guardar</b-button>
        </b-form>
        
        </sweet-modal>
        <sweet-modal ref="foldermodalmove">
            <b-form class="c-f-g-2-wrp sm" @submit="onSubmitChange">
            <b-form-group class="cus-f-group-2" label="Carpeta de destino">
                <b-form-select required v-model="form_change.folders_id" size="sm">
                    <b-form-select-option :value="null">Selecciona una opcion</b-form-select-option>
                    <b-form-select-option :value="s.id" v-for="(s, srInx) in folders" :key="'fold-'+srInx">{{ s.name }}</b-form-select-option>
                </b-form-select>
            </b-form-group>


            <b-button type="submit" class="btn-s1 bg-blue">Mover</b-button>

        </b-form>
        </sweet-modal>

    </div>
  </template>
  
  <script>
  export default {
    data(){
      return{
        activeFold:99999999,
        certificates: [],
        id: null,
        form_change:{
          check_signatured:[],
          folders_id:null,
        },
        rows:[],
        formfolder:{
          name:null
        },
        folders:[],
       
      }
    },
    watch:{
        'activeFold':function(val){
          var data = [];
          if(val == 99999999){
              data = this.certificates;
          }
          else{
            for (let z = 0; z < this.certificates.length; z++) {
              if(this.certificates[z]['folders_id'] == val){
                data.push(this.certificates[z]);
              }
              
            }
          }
            
          this.rows = data;
        }
    },
  
    methods: {
      getRows(){
        axios.get(tools.url("/api/user/certificates")).then((response)=>{
          this.certificates = response.data;
          this.rows = this.certificates;
        }).catch((error)=>{
            console.log(error);
        });
      },
      addFolder(){
        this.formfolder.name = null;
        this.formfolder.users_id = this.$root.user.id;
        this.$refs.foldermodal.open();
    },
    onSubmit(event){
      event.preventDefault()

        axios.post(tools.url('/api/user/folders'), this.formfolder).then((response)=>{
          this.$refs.foldermodal.close();
          this.getFolders();
        }).catch((error)=>{
          this.$refs.foldermodal.close();
            this.modal.block = false;
            this.modal.icon = "error";
            this.modal.msg = response.data.msg;
            
            this.handleErrors(error);
        });
    },
    getFolders(){
      
        axios.get(tools.url('/api/myfolders')).then((response)=>{
          this.folders = response.data;
        }).catch((error)=>{
        });
    },
    moveFolder(){
        if(this.form_change.check_signatured.length > 0){
            this.$refs.foldermodalmove.open();
        } 
        else{
          if(this.$i18n.locale == 'en'){
            alert('Select at least one document');
          }
          else{
            alert('Seleciona al menos un documento');
          }
            
        }

        
    },

    onSubmitChange(event){
      event.preventDefault()

        axios.post(tools.url('/api/user/foldersmove'), this.form_change).then((response)=>{
          this.form_change.check_signatured = [];
          this.form_change.folders_id = null;
          this.getContractsTwo();
          this.$refs.foldermodalmove.close();

          this.modal.block = false;
            this.modal.icon = "success";
            
            if(this.$i18n.locale == 'en'){
              this.modal.msg = 'Documents added to the folder';
            }
            else{
              this.modal.msg = 'Documentos agregados a la carpeta';
            }

            this.$refs.modal.open();
        }).catch((error)=>{
          this.$refs.foldermodalmove.close();
            this.modal.block = false;
            this.modal.icon = "error";
            this.modal.msg = response.data.msg;
            
            this.handleErrors(error);
        });
    },
    deleteFolder(){

        if (confirm('¿Seguro que deseas borrar esta carpeta?, tus documentos se iran al apartado "Todos"') == true) {
            axios.delete(tools.url('/api/user/folders/'+this.activeFold), this.form_change).then((response)=>{
              this.modal.block = false;
                this.modal.icon = "success";
                this.modal.msg = 'Carpeta elimina<br>tus documentos se ecuentran en el apartado "Todos"';
              this.$refs.modal.open();
              this.getContractsTwo();
              this.getFolders();
              this.activeFold = 99999999;
            }).catch((error)=>{
              
                this.modal.block = false;
                this.modal.icon = "error";
                this.modal.msg = response.data.msg;
                this.$refs.modal.open();
                
            });
        }
      


      

    },
    },
  
    mounted(){
      this.getFolders();
      if(this.$route.query.certificates_id){
        axios.get(tools.url("/api/user/certificates/"+this.$route.query.certificates_id)).then((response)=>{
          this.getRows();
        }).catch((error)=>{
            console.log(error);
        });
      }
      if(this.$root.logged){
          this.getRows();
      }
    }
  
  }
  </script>
  <style scoped="">
  body {font-family: Arial;}
  
  /* Style the tab */
  .tab {
    overflow: hidden;
    border: 1px solid #ccc;
    background-color: #f1f1f1;
  }
  
  /* Style the buttons inside the tab */
  .tab button {
    background-color: inherit;
    float: left;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 14px 16px;
    transition: 0.3s;
    font-size: 13px;
  }
  
  /* Change background color of buttons on hover */
  .tab button:hover {
    background-color: #ddd;
  }
  
  /* Create an active/current tablink class */
  .tab button.active {
    background-color: #ccc;
  }
  
  /* Style the tab content */
  .tabcontent {
    display: none;
    padding: 6px 12px;
    border: 1px solid #ccc;
    border-top: none;
  }
  </style>
  